module.exports = __webpack_public_path__ + "img/demography.c50e0074.png";